import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createOrderAndCharge, getCheckout, updateCheckout } from '@wix/ambassador-ecom-v1-checkout/http';
import { ambassadorWithHeaders } from '../../utils/ambassador.utils';
export class CheckoutService {
  constructor(httpClient, controllerConfig, getCurrency) {
    _defineProperty(this, "requestWithHeaders", void 0);
    this.requestWithHeaders = () => ambassadorWithHeaders(httpClient, controllerConfig, getCurrency());
  }
  async getCheckoutByCheckoutId(checkoutId) {
    const {
      data
    } = await this.requestWithHeaders()(getCheckout({
      id: checkoutId
    }));
    return data.checkout;
  }
  async createOrderAndCharge(_ref) {
    let {
      id,
      paymentToken,
      urlParams
    } = _ref;
    let orderId;
    let paymentResponseToken;
    try {
      const request = {
        id,
        paymentToken,
        urlParams
      };
      const {
        data
      } = await this.requestWithHeaders()(createOrderAndCharge(request));
      orderId = data.orderId;
      paymentResponseToken = data.paymentResponseToken;
    } catch (_unused) {
      orderId = undefined;
      paymentResponseToken = undefined;
    }
    return {
      orderId,
      paymentResponseToken
    };
  }
  async updateCheckoutForShippingEstimation(checkoutId, address) {
    const {
      data
    } = await this.requestWithHeaders()(updateCheckout({
      checkout: {
        id: checkoutId,
        shippingInfo: {
          shippingDestination: {
            address
          }
        }
      },
      fieldMask: ['shippingInfo.shippingDestination.address.country', 'shippingInfo.shippingDestination.address.postalCode', 'shippingInfo.shippingDestination.address.subdivision']
    }));
    return data.checkout;
  }
  async updateCheckoutByShippingAndBillingContacts(checkoutId, shouldUpdateShippingAddress, shippingContact, billingContact) {
    var _shippingContact$name, _shippingContact$name2;
    const {
      data
    } = await this.requestWithHeaders()(updateCheckout({
      checkout: {
        id: checkoutId,
        ...(shouldUpdateShippingAddress && {
          shippingInfo: {
            shippingDestination: {
              address: {
                country: shippingContact == null ? void 0 : shippingContact.country,
                subdivision: shippingContact == null ? void 0 : shippingContact.subdivision,
                postalCode: shippingContact == null ? void 0 : shippingContact.zipCode,
                city: shippingContact == null ? void 0 : shippingContact.city,
                addressLine: shippingContact == null ? void 0 : shippingContact.addressLine1,
                addressLine2: shippingContact == null ? void 0 : shippingContact.addressLine2
              },
              contactDetails: {
                firstName: shippingContact == null ? void 0 : (_shippingContact$name = shippingContact.name) == null ? void 0 : _shippingContact$name.firstName,
                lastName: shippingContact == null ? void 0 : (_shippingContact$name2 = shippingContact.name) == null ? void 0 : _shippingContact$name2.lastName,
                phone: (shippingContact == null ? void 0 : shippingContact.phoneNumber) || undefined
              }
            }
          }
        }),
        buyerInfo: {
          email: billingContact == null ? void 0 : billingContact.email
        },
        billingInfo: {
          address: {
            country: billingContact == null ? void 0 : billingContact.countryCode,
            postalCode: billingContact == null ? void 0 : billingContact.postalCode,
            city: billingContact == null ? void 0 : billingContact.city,
            subdivision: billingContact == null ? void 0 : billingContact.state
          },
          contactDetails: {
            firstName: billingContact == null ? void 0 : billingContact.firstName,
            lastName: billingContact == null ? void 0 : billingContact.lastName,
            phone: billingContact == null ? void 0 : billingContact.phone
          }
        }
      },
      fieldMask: ['billingInfo', 'buyerInfo.email', ...(shouldUpdateShippingAddress ? ['shippingInfo.shippingDestination'] : [])]
    }));
    return data.checkout;
  }
  async setShippingOption(checkoutId, shippingOptionId) {
    const {
      data
    } = await this.requestWithHeaders()(updateCheckout({
      checkout: {
        id: checkoutId,
        shippingInfo: {
          selectedCarrierServiceOption: {
            code: shippingOptionId
          }
        }
      },
      fieldMask: ['shippingInfo.selectedCarrierServiceOption']
    }));
    return data.checkout;
  }
}
//# sourceMappingURL=CheckoutService.js.map